import { SvgAccount } from "./components/Account";
import { SvgAdd } from "./components/Add";
import { SvgArrowDown } from "./components/ArrowDown";
import { SvgArrowLeft } from "./components/ArrowLeft";
import { SvgArrowRight } from "./components/ArrowRight";
import { SvgArrowRight2 } from "./components/ArrowRight2";
import { SvgArrowUp } from "./components/ArrowUp";
import { SvgBlankX } from "./components/BlankX";
import { SvgCheckmark } from "./components/Checkmark";
import { SvgCheckmarkRounded } from "./components/CheckmarkRounded";
import { SvgCheckmarkInCircle } from "./components/CheckmarkInCircle";
import { SvgClose } from "./components/Close";
import { SvgDashRounded } from "./components/DashRounded";
import { SvgFilter } from "./components/Filter";
import { SvgHamburger } from "./components/Hamburger";
import { SvgInfo } from "./components/Info";
import { SvgInsideBubbleArrow } from "./components/InsideBubbleArrow";
import { SvgLoading } from "./components/Loading";
import { SvgLocation } from "./components/Location";
import { SvgLock } from "./components/Lock";
import { SvgMedicationAccess } from "./components/MedicationAccess";
import { SvgMinus } from "./components/Minus";
import { SvgOffer } from "./components/Offer";
import { SvgPauseBackgroundVideo } from "./components/PauseBackgroundVideo";
import { SvgPhone } from "./components/Phone";
import { SvgPlayAltRounded } from "./components/PlayAltRounded";
import { SvgPlayBackgroundVideo } from "./components/PlayBackgroundVideo";
import { SvgPlus } from "./components/Plus";
import { SvgPrimaryLink } from "./components/PrimaryLink";
import { SvgPromoCheck } from "./components/PromoCheck";
import { SvgSearch } from "./components/Search";
import { SvgServings } from "./components/Servings";
import { SvgSocialFacebookRound } from "./components/SocialFacebookRound";
import { SvgSocialFacebook } from "./components/SocialFacebook";
import { SvgSocialInstagramRound } from "./components/SocialInstagramRound";
import { SvgSocialInstagram } from "./components/SocialInstagram";
import { SvgSocialLinkedinRound } from "./components/SocialLinkedinRound";
import { SvgSocialPinterestRound } from "./components/SocialPinterestRound";
import { SvgSocialPinterest } from "./components/SocialPinterest";
import { SvgSocialTwitterRound } from "./components/SocialTwitterRound";
import { SvgSocialTwitter } from "./components/SocialTwitter";
import { SvgSocialYoutubeRound } from "./components/SocialYoutubeRound";
import { SvgSocialYoutube } from "./components/SocialYoutube";
import { SvgStatusCheck } from "./components/StatusCheck";
import { SvgStatusLoading } from "./components/StatusLoading";
import { SvgTrashcan } from "./components/Trashcan";
import { SvgWwLogo } from "./components/WwLogo";
import { SvgWwLogoNoText } from "./components/WwLogoNoText";
import { SvgFreestyleLogo } from "./components/FreestyleLogo";
import { SvgWwTextNoLogo } from "./components/WwTextNoLogo";
import { SvgCarouselLeft } from "./components/CarouselLeft";
import { SvgCarouselRight } from "./components/CarouselRight";
export var Icons = {
  account: SvgAccount,
  add: SvgAdd,
  'arrow-down': SvgArrowDown,
  'arrow-left': SvgArrowLeft,
  'arrow-right': SvgArrowRight,
  'arrow-right-2': SvgArrowRight2,
  'arrow-up': SvgArrowUp,
  'blank-x': SvgBlankX,
  checkmark: SvgCheckmark,
  'checkmark-rounded': SvgCheckmarkRounded,
  'checkmark-in-circle': SvgCheckmarkInCircle,
  close: SvgClose,
  'dash-rounded': SvgDashRounded,
  filter: SvgFilter,
  hamburger: SvgHamburger,
  info: SvgInfo,
  lock: SvgLock,
  loading: SvgLoading,
  location: SvgLocation,
  'inside-bubble-arrow': SvgInsideBubbleArrow,
  'medication-access': SvgMedicationAccess,
  minus: SvgMinus,
  offer: SvgOffer,
  'pause-background-video': SvgPauseBackgroundVideo,
  phone: SvgPhone,
  'play-alt-rounded': SvgPlayAltRounded,
  'play-background-video': SvgPlayBackgroundVideo,
  plus: SvgPlus,
  'primary-link': SvgPrimaryLink,
  'promo-check': SvgPromoCheck,
  search: SvgSearch,
  servings: SvgServings,
  'social-facebook-round': SvgSocialFacebookRound,
  'social-facebook': SvgSocialFacebook,
  'social-instagram-round': SvgSocialInstagramRound,
  'social-instagram': SvgSocialInstagram,
  'social-linkedin-round': SvgSocialLinkedinRound,
  'social-pinterest-round': SvgSocialPinterestRound,
  'social-pinterest': SvgSocialPinterest,
  'social-twitter-round': SvgSocialTwitterRound,
  'social-twitter': SvgSocialTwitter,
  'social-youtube-round': SvgSocialYoutubeRound,
  'social-youtube': SvgSocialYoutube,
  'status-check': SvgStatusCheck,
  'status-loading': SvgStatusLoading,
  trashcan: SvgTrashcan,
  'ww-logo': SvgWwLogo,
  'ww-logo-no-text': SvgWwLogoNoText,
  'freestyle-logo': SvgFreestyleLogo,
  'ww-text-no-logo': SvgWwTextNoLogo,
  'carousel-left': SvgCarouselLeft,
  'carousel-right': SvgCarouselRight
};
export default Icons;